import { render, staticRenderFns } from "./recharge_detail.vue?vue&type=template&id=63506040&scoped=true"
import script from "./recharge_detail.vue?vue&type=script&lang=js"
export * from "./recharge_detail.vue?vue&type=script&lang=js"
import style0 from "./recharge_detail.vue?vue&type=style&index=0&id=63506040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63506040",
  null
  
)

export default component.exports